import React from 'react';
import format from 'date-fns/format';

import { SyncOutlined } from '@ant-design/icons';
import InfoItem from './InfoItem';

function Sync({ t, problemSync, lastSync, percent }) {
  return [
    problemSync && (
      <InfoItem icon={<SyncOutlined />} text={t('sync-error')} color="danger" />
    ),
    lastSync && (
      <InfoItem
        icon={<SyncOutlined />}
        text={format(new Date(lastSync), 'dd.MM.yy, HH:mm')}
        color={percent === -1 ? 'success' : 'danger'}
      />
    ),
  ];
}

export default Sync;
